import React, { Component } from "react";
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";

import "./integration.css";
import Adint from '../../component/settings/ad/ad'

export default class Ad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }
    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title"><span onClick={(e) => this.props.history.push("/integration")} className="bar_Icons mr-2"><ArrowBackSharpIcon className="btn-icon" /></span>AD Integration</h4>

                            </div>
                        </div>
                        {/* <div className="col-md-8 flexFilterButtons"> </div> */}
                    </div>
                </div>

                <div className="contentbar">
                    <Adint />
                </div>
            </div>
        );
    }
}